import { useParams, useSearch } from "@tanstack/react-router";

/**
 * Where am I? Read the current workspace, project and environment from the URL.
 * Every screen under /$workspace/$project can call these instead of threading props.
 *
 *   const project = useProjectSlug();         // "primecarers"
 *   const env = useEnvName();                 // "production" (from ?env=, default production)
 *   const { data } = useServiceInstances(project, env);
 */
export function useWorkspaceSlug(): string {
  const p = useParams({ strict: false }) as { workspace?: string };
  return p.workspace ?? "";
}

export function useProjectSlug(): string {
  const p = useParams({ strict: false }) as { project?: string };
  return p.project ?? "";
}

/** The selected environment name. Lives in the `?env=` search param so links are shareable. */
export function useEnvName(): string {
  const s = useSearch({ strict: false }) as { env?: string };
  return s.env ?? "production";
}
